import * as actions from './actions'
import * as getters from './getters'
import * as mutations from './mutations'

const state = {
  shappy: {
    user_info: {
      username: '',
      firstname: '',
      lastname: '',
      email: '',
      mobile: '',
      address: '',
      member: ''
    },
    status: false
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/shappy/index.js